import { render, staticRenderFns } from "./mockup.vue?vue&type=template&id=7de5311e&scoped=true"
import script from "./mockup.vue?vue&type=script&lang=js"
export * from "./mockup.vue?vue&type=script&lang=js"
import style0 from "./mockup.vue?vue&type=style&index=0&id=7de5311e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de5311e",
  null
  
)

export default component.exports